import React from 'react';
import Modal from './Modal';

// ============================================
// SHARED CONFIRM DIALOG
// Replaces native window.confirm() / alert()
// black boxes with the app's in-app modal.
// ============================================
function ConfirmDialog({ isOpen, onClose, title = 'Confirm', message, onConfirm, confirmLabel = 'Confirm', danger = false }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title}>
      <p className="text-gray-600 text-sm mb-6" style={{ whiteSpace: 'pre-line' }}>{message}</p>
      <div className="flex justify-end gap-3">
        <button
          onClick={onClose}
          className="px-4 py-2 rounded-lg border border-gray-200 text-sm hover:bg-gray-50"
        >
          Cancel
        </button>
        <button
          onClick={() => { onConfirm(); onClose(); }}
          className={`px-6 py-2 rounded-lg text-sm font-semibold text-white ${danger ? 'bg-red-600 hover:bg-red-700' : 'bg-green hover:bg-green-600'}`}
        >
          {confirmLabel}
        </button>
      </div>
    </Modal>
  );
}

export default ConfirmDialog;
